/**
 * NWS Product Card - Global JavaScript
 * Handles Add to Cart, Wishlist text updates
 * Quick View is handled by nws-shared-quick-view.liquid
 */

(function () {
  'use strict';

  // Initialize product card functionality
  function initProductCards(container) {
    const scope = container || document;

    // Add to Cart functionality
    initAddToCart(scope);

    // Wishlist text updates
    initWishlistText(scope);

    // Prevent action buttons from triggering parent link
    preventLinkPropagation(scope);
  }

  // Add to Cart with cart drawer opening
  function initAddToCart(scope) {
    scope.querySelectorAll('form[data-type="add-to-cart-form"]').forEach(form => {
      // Remove existing listener if any
      form.removeEventListener('submit', handleAddToCart);
      form.addEventListener('submit', handleAddToCart);
    });
  }

  function handleAddToCart(e) {
    e.preventDefault();

    const form = e.target;
    const submitButton = form.querySelector('button[type="submit"]');
    const buttonText = submitButton.querySelector('[data-add-to-cart-text]');
    const soldOutMessage = submitButton.querySelector('.sold-out-message');
    const spinner = submitButton.querySelector('.loading-overlay__spinner');

    if (!submitButton || !buttonText || !spinner) return;

    // Store original text
    const originalText = buttonText.textContent;

    // Show loading spinner
    buttonText.style.display = 'none';
    spinner.classList.remove('hidden');
    submitButton.disabled = true;

    // Get variant ID
    const variantId = form.querySelector('input[name="id"]')?.value;

    if (!variantId) {
      console.error('No variant ID found');
      resetButton();
      return;
    }

    // Submit to cart
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{
          id: variantId,
          quantity: 1
        }]
      })
    })
      .then(response => response.json())
      .then(data => {
        // Hide spinner, show success
        spinner.classList.add('hidden');
        buttonText.style.display = 'inline';
        buttonText.textContent = 'Added!';
        submitButton.disabled = false;

        // Dispatch ajaxProduct:added event - CartDrawer listens to this and will rebuild + open
        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: { product: data }
        }));

        // Also dispatch cart:build to ensure cart is rebuilt
        document.dispatchEvent(new CustomEvent('cart:build'));

        // Fetch updated cart and update displays
        fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            // Update cart count bubble
            const cartCountBubble = document.querySelector('.cart-link__bubble');
            if (cartCountBubble) {
              if (cart.item_count > 0) {
                cartCountBubble.classList.add('cart-link__bubble--visible');
              }
            }

            // Update any cart count text
            const cartCount = document.querySelector('.cart-count-bubble');
            if (cartCount) {
              cartCount.textContent = cart.item_count;
            }

            // Dispatch cart updated event for discount display
            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: cart
            }));
          });

        // Reset button text after 2 seconds
        setTimeout(() => {
          buttonText.textContent = originalText;
        }, 2000);
      })
      .catch(error => {
        console.error('Add to cart error:', error);
        resetButton();
      });

    function resetButton() {
      spinner.classList.add('hidden');
      buttonText.style.display = 'inline';
      buttonText.textContent = 'Error';
      submitButton.disabled = false;

      setTimeout(() => {
        buttonText.textContent = originalText;
      }, 2000);
    }
  }

  // Wishlist text updates based on Swishlist app state
  function initWishlistText(scope) {
    const wishlistButtons = scope.querySelectorAll('.nws-wishlist-btn');

    if (wishlistButtons.length === 0) return;

    // Update text function
    const updateWishlistText = (button) => {
      const textSpan = button.querySelector('.nws-wishlist-text');
      if (textSpan) {
        // Get text from settings (if available globally)
        const addedText = window.wishlistSettings?.addedText || 'Remove from Wishlist';
        const addText = window.wishlistSettings?.addText || 'Add to Wishlist';

        if (button.classList.contains('st-active')) {
          textSpan.textContent = addedText;
        } else {
          textSpan.textContent = addText;
        }
      }
    };

    // Initial update for all buttons
    wishlistButtons.forEach(button => {
      updateWishlistText(button);

      // Watch for class changes
      const observer = new MutationObserver(() => {
        updateWishlistText(button);
      });

      observer.observe(button, {
        attributes: true,
        attributeFilter: ['class']
      });
    });
  }

  // Prevent action buttons from triggering parent product link
  function preventLinkPropagation(scope) {
    // Prevent clicks on action buttons from bubbling to parent link
    // Prevent clicks on action buttons from bubbling to parent link
    // NOTE: Removed stopPropagation for Quick View and Wishlist as they rely on document-level delegation
    const actionButtons = scope.querySelectorAll('.nws-action-btn, button[data-type="submit"]');

    actionButtons.forEach(button => {
      // Only stop propagation if it's NOT a quick view or wishlist button
      if (!button.classList.contains('nws-quick-view-btn') && !button.classList.contains('nws-wishlist-btn')) {
        button.addEventListener('click', function (e) {
          e.stopPropagation();
        }, true);
      }
    });

    // Prevent form submissions from triggering parent link
    const forms = scope.querySelectorAll('form[data-type="add-to-cart-form"]');

    forms.forEach(form => {
      form.addEventListener('click', function (e) {
        e.stopPropagation();
      }, true);
    });

    // NOTE: Overlays stopPropagation removed to allow button clicks
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initProductCards(document);
    });
  } else {
    initProductCards(document);
  }

  // Expose for reinitialization after AJAX loads
  window.NWSProductCard = {
    init: initProductCards,
    initAddToCart: initAddToCart,
    initWishlistText: initWishlistText,
    preventLinkPropagation: preventLinkPropagation
  };

  // Listen for custom events to reinitialize
  document.addEventListener('product-cards:reinit', function (e) {
    const container = e.detail?.container || document;
    initProductCards(container);
  });

})();

// Set wishlist text from theme settings (called from layout/theme.liquid)
if (typeof Shopify !== 'undefined' && Shopify.theme) {
  window.wishlistSettings = {
    addText: Shopify.theme.wishlistAddText || 'Add to Wishlist',
    addedText: Shopify.theme.wishlistAddedText || 'Remove from Wishlist'
  };
}